import { useParams } from "react-router-dom";
import SaveKitInventariable from "../../shared/component/save-kit-inventariable/SaveKitInventariable";
import { fetchGetKitInventarioById } from "@/shared/actions/erp/kitinventario/kitInventario.actions";
import { LoaderComponent } from "@/shared/components/ui";
import { useEffect } from "react";

export default function KitInventarioEditPage() {

  const { id } = useParams()
  
  const { data, isLoading } = fetchGetKitInventarioById(id!)
  
  useEffect(() => {
    if (!isLoading || !data) return;

  }, [isLoading]);

  if (isLoading) return <LoaderComponent />


  return <SaveKitInventariable
    title={'Editar Kit'}
    dataKitInventario={data?.data}

  />

}